import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import FaqComponents from "../components/common/faq";

const faqs = [
  {
    question: "How much does it cost to build a cloud-based application?",
    answer: `<p>The cost to build a cloud-based application with TekRevol typically ranges from $40,000 to $250,000, depending on the complexity, features, and specific requirements of your project.</p>`,
  },
  {
    question:
      "What cloud security measures does TekRevol take for its clients?",
    answer: `<p>TekRevol implements comprehensive security measures including end-to-end encryption, multi-factor authentication, regular security audits, and compliance with industry standards such as ISO 27001 and GDPR. We also utilize advanced threat detection and monitoring tools to safeguard your data.</p>`,
  },
  {
    question: "How is TekRevol different from other cloud service companies?",
    answer: `<p>TekRevol stands out due to our deep expertise in cloud technologies, personalized approach to each project, and a proven track record of successful cloud migrations and optimizations. We prioritize technical excellence, client-specific solutions, and continuous support to ensure your cloud infrastructure performs at its best.</p>`,
  },
  {
    question: "What kind of cloud support services does TekRevol offer?",
    answer: `<p>TekRevol offers a range of cloud support services including 24/7 monitoring, performance optimization, security management, regular updates and maintenance, and dedicated technical support to address any issues promptly.</p>`,
  },
  {
    question: "Can TekRevol help migrate existing applications to the cloud?",
    answer: `<p>Yes, TekRevol specializes in seamless cloud migration services. We assess your current infrastructure, plan the migration strategy, and execute the transfer with minimal downtime and disruption, ensuring your applications are optimized for cloud performance.</p>`,
  },
  {
    question:
      "How does TekRevol ensure data recovery and backup in case of a disaster?",
    answer: `<p>TekRevol employs robust disaster recovery and backup solutions, including automated backup schedules, real-time data replication, and failover mechanisms. Our disaster recovery plans are tailored to your business needs, ensuring quick data recovery and minimal impact on your operations.</p>`,
  },
];

function FaqLocation(props) {
  return (
    <div className="faq_loc p-100 tekrevol_dark_bg">
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <div className="example center text-center" data-text="FAQs">
              <h2>Cloud Computing Consultants FAQs</h2>
            </div>
          </Col>
        </Row>
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="services_faqs"
          >
            <FaqComponents faqs={faqs} />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default FaqLocation;
